export default {
  LOGIN_DETAILS_LIST_REQUEST: 'APP/LOGIN_DETAILS/LOGIN_DETAILS_LIST_REQUEST',
  LOGIN_DETAILS_LIST_SUCCESS: 'APP/LOGIN_DETAILS/LOGIN_DETAILS_LIST_SUCCESS',
  LOGIN_DETAILS_LIST_ERROR: 'APP/LOGIN_DETAILS/LOGIN_DETAILS_LIST_ERROR',
};
